import Image from "next/image";
import { useTranslation } from "next-i18next";
import { useRecoilValue } from "recoil";

import { ShipdaCurrentLanguage } from "@sellernote/shared/src/i18n/i18nForShipda";
import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import { addEventToGTMDataLayer } from "@sellernote/features/src/common/utils/gtm";
import { FORWARDING_AUTH_ATOMS } from "@sellernote/features/src/forwarding/recoil-states/auth";
import LandingQuickActions from "@sellernote/shipda-kr/src/components/landing/LandingQuickActions";
import LandingSectionServiceIntro from "@sellernote/shipda-kr/src/components/landing/LandingSectionServiceIntro";
import LandingSubSectionList from "@sellernote/shipda-kr/src/components/landing/LandingSubSectionList";
import Layout from "@sellernote/shipda-kr/src/containers/Layout";
import Seo from "@sellernote/shipda-kr/src/containers/Seo";
import SuspenseWrapper from "@sellernote/shipda-kr/src/containers/SuspenseWrapper";
import Loading from "@sellernote/ui/src/sds-v1/components/Loading";
import SubMenuSourcingIcon from "@sellernote/ui/src/sds-v2/components/svgIcons/SubMenuSourcingIcon";

import useAlibabaSourcing from "../../hooks/common/useAlibabaSourcing";
import useCustomizeFloatingButtonAreaPosition from "../../hooks/common/useCustomizeFloatingButtonAreaPosition";
import { getServerSidePropsWithI18n } from "../../utils/i18n";

import { AlibabaCouponSection } from "./AlibabaCouponSection";
import { CouponConditionSection } from "./CouponConditionSection";
import {
  ALIBABA_SOURCING_COLOR,
  SERVICE_INTRO_SECTION_DATA,
  SUB_SECTION_DATA,
} from "./DATA";
import FaqSection from "./FaqSection";
import MoveRegisterSection from "./MoveRegisterSection";
import Styled from "./index.styles";

export const getServerSideProps = getServerSidePropsWithI18n();

export default function Tt() {
  const { t } = useTranslation(["page-sourcing"]);

  const { alibabaUrl, alibabaGtmEvent } = useAlibabaSourcing();

  const isLoggedIn = useRecoilValue(FORWARDING_AUTH_ATOMS.USER_LOGGED_IN);

  const { isMobile } = useCheckIsMobile();

  // Mobile에서는 최하단에 버튼이 생기므로 플로팅 버튼 영역 위치를 조정
  useCustomizeFloatingButtonAreaPosition({
    position: 82,
    disabled: !isMobile,
  });

  return (
    <Layout size="full">
      <Seo
        path="/sourcing"
        title={
          ShipdaCurrentLanguage.currentLanguage === "ko"
            ? "상품소싱 - 쉽다 x 알리바바 제휴 안내"
            : "Sourcing - Ship-da - Digital freight forwarding service"
        }
        description={
          ShipdaCurrentLanguage.currentLanguage === "ko"
            ? "알리바바 닷컴에서 상품 소싱하고 디지털 포워딩 서비스 할인받으세요."
            : "Source products on Alibaba.com and enjoy discounts on digital forwarding services."
        }
      />

      <SuspenseWrapper fallback={<Loading active Image={Image} />}>
        <Styled.container>
          <LandingSectionServiceIntro
            {...SERVICE_INTRO_SECTION_DATA}
            iconInfo={{ Icon: SubMenuSourcingIcon, isCustomColor: false }}
            buttonInfo={{
              label: t("page-sourcing:알리바바닷컴_시작하기"),
              onClick: () => {
                window.open(alibabaUrl, "_blank");
                addEventToGTMDataLayer(alibabaGtmEvent);
              },
              color: ALIBABA_SOURCING_COLOR,
            }}
            showsRequestServiceGuide={false}
            showsIntroGuideProps={false}
          />

          <AlibabaCouponSection />

          <CouponConditionSection />

          <MoveRegisterSection />

          <LandingSubSectionList
            data={SUB_SECTION_DATA}
            firstSectionBackgroundType="gray"
          />

          <FaqSection />

          <LandingQuickActions />
        </Styled.container>
      </SuspenseWrapper>
    </Layout>
  );
}
